import axios from "axios";
import { setCsrfToken, clearCsrfToken } from "./csrf";
import { disconnectSocket } from "./socket";
import { buildAccessMapFromServices } from "./utils/roleAccess";

// ===============================
// AUTH STORAGE KEYS
// ===============================
export const AuthKey = "APP_AUTH_TOKEN";
export const UserKey = "APP_USER_INFO";

// ===============================
// SAVE AUTH USER (COOKIE HOLDS THE JWT)
// ===============================
export const setAuth = ({ user }) => {
  try {
    if (user) {
      const serializedUser = JSON.stringify(user);
      sessionStorage.setItem(UserKey, serializedUser);
      localStorage.setItem(UserKey, serializedUser);
    }

    // Legacy cleanup: auth is cookie-based, so no token belongs in storage.
    sessionStorage.removeItem(AuthKey);
    localStorage.removeItem(AuthKey);
  } catch (err) {
    console.error("Failed to set auth:", err);
  }
};

// ===============================
// GET TOKEN
// ===============================
export const getToken = () => "";

// ===============================
// GET USER
// ===============================
export const getUser = () => {
  try {
    const raw =
      sessionStorage.getItem(UserKey) || localStorage.getItem(UserKey);
    if (!raw) return null;

    const user = JSON.parse(raw);
    sessionStorage.setItem(UserKey, JSON.stringify(user));
    return user;
  } catch {
    return null;
  }
};

// ===============================
// AUTH STATUS
// ===============================
export const isAuthenticated = () => {
  return !!getUser();
};

// ===============================
// FETCH /auth/me — RE-HYDRATE CSRF TOKEN ON PAGE REFRESH
// ===============================
export const fetchAuthMe = async () => {
  const { data } = await axios.get("/auth/me", {
    headers: { "x-skip-auth-redirect": true },
  });

  if (data.csrfToken) setCsrfToken(data.csrfToken);
};

// ===============================
// CLEAR AUTH (LOGOUT / SESSION RESET)
// ===============================
export const clearAuth = () => {
  try {
    clearCsrfToken();
    disconnectSocket();

    sessionStorage.removeItem(AuthKey);
    sessionStorage.removeItem(UserKey);

    localStorage.removeItem(AuthKey);
    localStorage.removeItem(UserKey);
    localStorage.removeItem("authToken");
  } catch (err) {
    console.error("Failed to clear auth:", err);
  }
};
